import { DropDownList } from "@progress/kendo-react-dropdowns";
import { currencies } from "../../constants";

export default function LocalizationSettings({
  draft,
  fontSizeOptions,
  languageOptions,
  onChange,
  onPreviewLanguage,
  t = {}
}) {
  return (
    <div className="panel">
      <div className="section-heading">
        <div>
          <p className="eyebrow">{t.preferences || "Preferences"}</p>
          <h3>{t.localeAndDisplay || "Locale and display"}</h3>
        </div>
      </div>
      <div className="settings-two-column">
        <div className="field">
          <label>{t.displayCurrency || "Display currency"}</label>
          <DropDownList
            data={currencies}
            textField="text"
            dataItemKey="value"
            value={currencies.find((currency) => currency.value === draft.currency?.value)}
            onChange={(event) => onChange({ currency: event.value })}
          />
        </div>
        <div className="field">
          <label>{t.language || "Language"}</label>
          <DropDownList
            data={languageOptions}
            textField="text"
            dataItemKey="value"
            value={languageOptions.find((language) => language.value === draft.language?.value)}
            onChange={(event) => {
              onChange({ language: event.value });
              onPreviewLanguage(event.value);
            }}
          />
        </div>
        <div className="field full">
          <label>{t.fontSize || "Font size"}</label>
          <DropDownList
            data={fontSizeOptions}
            textField="text"
            dataItemKey="value"
            value={fontSizeOptions.find((fontSize) => fontSize.value === draft.fontSize?.value)}
            onChange={(event) => onChange({ fontSize: event.value })}
          />
        </div>
      </div>
    </div>
  );
}
